module.exports = __webpack_public_path__ + "img/98_7.c36f3988.png";